import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import HomePage from "@/pages/HomePage";
import CatalogPage from "@/pages/CatalogPage";
import ProductPage from "@/pages/ProductPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderConfirmationPage from "@/pages/OrderConfirmationPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminPage from "@/pages/AdminPage";
import CookieBanner from "@/components/CookieBanner";
import { PogojiPoslovanja, Piskotki, PravnaObvestila } from "@/pages/LegalPages";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Header />
          <CartDrawer />
          <CookieBanner />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/trgovina" element={<CatalogPage />} />
              <Route path="/izdelek/:id" element={<ProductPage />} />
              <Route path="/blagajna" element={<CheckoutPage />} />
              <Route path="/narocilo/:id" element={<OrderConfirmationPage />} />
              <Route path="/admin/prijava" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/pogoji-poslovanja" element={<PogojiPoslovanja />} />
              <Route path="/piskotki" element={<Piskotki />} />
              <Route path="/pravna-obvestila" element={<PravnaObvestila />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
